import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TwoFactorSetupForm from '../../components/application/authentication/TwoFactorSetupForm';
import RecoveryCodesModal from '../../components/application/authentication/RecoveryCodesModal';
import {
    twoFactorQRCodeSelector,
    twoFactorSecretSelector,
    twoFactorCodeSelector,
    twoFactorSubmittingSelector,
    twoFactorErrorSelector,
    twoFactorRequiresSetupSelector,
    twoFactorRecoveryCodesSelector,
    twoFactorShowRecoveryCodesSelector
} from '../../selectors/authentication';
import {
    inputTwoFactor,
    fetchTwoFactorSetup,
    verifyTwoFactorSetup,
    cancelTwoFactor,
    hideRecoveryCodes
} from '../../actions/twoFactor';

class TwoFactorSetup extends Component {
    componentDidMount() {
        // Fetch the QR code when component mounts
        if (this.props.requiresSetup) {
            this.props.fetchTwoFactorSetup();
        }
    }

    _onSubmit = () => {
        this.props.verifyTwoFactorSetup(this.props.code);
    };

    _onInput = (value, key) => {
        // Only allow numeric input
        const numericValue = value.replace(/\D/g, '');
        this.props.inputTwoFactor(numericValue, key);
    };

    _onCancel = () => {
        this.props.cancelTwoFactor();
    };

    _onRecoveryCodesClose = () => {
        this.props.hideRecoveryCodes();
    };

    render() {
        // Show recovery codes modal if 2FA setup was successful and codes are available
        if (this.props.showRecoveryCodes && this.props.recoveryCodes) {
            return <RecoveryCodesModal recoveryCodes={this.props.recoveryCodes} onClose={this._onRecoveryCodesClose} />;
        }

        return (
            <TwoFactorSetupForm
                qrCode={this.props.qrCode}
                secret={this.props.secret}
                code={this.props.code}
                onInput={this._onInput}
                onSubmit={this._onSubmit}
                onCancel={this._onCancel}
                loading={this.props.loading}
                errorText={this.props.error}
            />
        );
    }
}

const mapStateToProps = state => ({
    requiresSetup: twoFactorRequiresSetupSelector(state),
    qrCode: twoFactorQRCodeSelector(state),
    secret: twoFactorSecretSelector(state),
    code: twoFactorCodeSelector(state),
    loading: twoFactorSubmittingSelector(state),
    error: twoFactorErrorSelector(state),
    recoveryCodes: twoFactorRecoveryCodesSelector(state),
    showRecoveryCodes: twoFactorShowRecoveryCodesSelector(state)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            inputTwoFactor,
            fetchTwoFactorSetup,
            verifyTwoFactorSetup,
            cancelTwoFactor,
            hideRecoveryCodes
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(TwoFactorSetup);
